import { Injectable, signal } from '@angular/core';
import { ModalType } from '@app/core/enums/modal.enums';
import { WidgetType } from '@app/core/enums/widget/widget-type.enum';
@Injectable({
  providedIn: 'root',
})
export class DynamicImportService {
  private slots: Map<string, ComponentProvider> = new Map<
    string,
    ComponentProvider
  >();
  private dynamicModals: Map<string, any> = new Map<string, any>();
  private loadedComponents: Map<string, any> = new Map<string, any>();
  private loadedModals: Map<string, any> = new Map<string, any>();
  showLoadingBar = signal(false);
  constructor() {}

  init(widgetsType: WidgetType[]) {
    this.setSlots(widgetsType);
  }

  private setSlots(widgetsType: WidgetType[]) {
    const shouldLoadWidget = (widgetType: WidgetType): boolean => {
      return widgetsType.includes(widgetType) && !this.slots.has(widgetType);
    };

    if (shouldLoadWidget(WidgetType.BUTTON)) {
      this.slots.set(
        WidgetType.BUTTON,
        new ComponentProvider(
          true,
          import('@app/widgets/button/button.component').then(
            (c) => c.ButtonComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.DYNAMIC_INPUT)) {
      this.slots.set(
        WidgetType.DYNAMIC_INPUT,
        new ComponentProvider(
          true,
          import('@app/widgets/input-type/input-type.component').then(
            (c) => c.InputTypeComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ICON)) {
      this.slots.set(
        WidgetType.ICON,
        new ComponentProvider(
          true,
          import('@app/widgets/icons/icons.component').then(
            (c) => c.IconsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.FIXED_BOTTOM_BAR)) {
      this.slots.set(
        WidgetType.FIXED_BOTTOM_BAR,
        new ComponentProvider(
          true,
          import('@app/widgets/fixed-bottom-bar/fixed-bottom-bar.component').then(
            (c) => c.FixedBottomBarComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.APP_INSTALL_BANNER)) {
      this.slots.set(
        WidgetType.APP_INSTALL_BANNER,
        new ComponentProvider(
          true,
          import('@app/widgets/app-install-banner/app-install-banner.component').then(
            (c) => c.AppInstallBannerComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ADD_MORE_ADDRESS)) {
      this.slots.set(
        WidgetType.ADD_MORE_ADDRESS,
        new ComponentProvider(
          true,
          import('@app/widgets/banners-widget/banners-widget.component').then(
            (i) => i.BannersWidgetComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ADS_V2)) {
      this.slots.set(
        WidgetType.ADS_V2,
        new ComponentProvider(
          true,
          import('@app/widgets/related-video/related-video.component').then(
            (c) => c.RelatedVideoComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ALL_CATEGORIES)) {
      this.slots.set(
        WidgetType.ALL_CATEGORIES,
        new ComponentProvider(
          true,
          import('@app/widgets/all-categories/all-categories.component').then(
            (i) => i.AllCategoriesComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.BANNER)) {
      this.slots.set(
        WidgetType.BANNER,
        new ComponentProvider(
          true,
          import('@app/widgets/banners-widget/banners-widget.component').then(
            (i) => i.BannersWidgetComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.BREADCRUMBS)) {
      this.slots.set(
        WidgetType.BREADCRUMBS,
        new ComponentProvider(
          true,
          import('@app/widgets/breadcrumbs/breadcrumbs.component').then(
            (c) => c.BreadcrumbsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.BULK_QUANTITY_DISCOUNT)) {
      this.slots.set(
        WidgetType.BULK_QUANTITY_DISCOUNT,
        new ComponentProvider(
          true,
          import('@app/widgets/bulk-quantity-discount/bulk-quantity-discount.component').then(
            (c) => c.BulkQuantityDiscountComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.CATEGORIES)) {
      this.slots.set(
        WidgetType.CATEGORIES,
        new ComponentProvider(
          true,
          import('@app/widgets/categories-list/categories-list.component').then(
            (i) => i.CategoriesListComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.CHECK_DELIVERY_DETAILS)) {
      this.slots.set(
        WidgetType.CHECK_DELIVERY_DETAILS,
        new ComponentProvider(
          true,
          import('@app/widgets/check-delivery-details/check-delivery-details.component').then(
            (c) => c.CheckDeliveryDetailsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.COMPOSED_RATING_REVIEW)) {
      this.slots.set(
        WidgetType.COMPOSED_RATING_REVIEW,
        new ComponentProvider(
          true,
          import('@app/widgets/composed-rating-review/composed-rating-review.component').then(
            (c) => c.ComposedRatingReviewComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.CREATIVE_CARD)) {
      this.slots.set(
        WidgetType.CREATIVE_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/creative-card/creative-card.component').then(
            (i) => i.CreativeCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.THANK_YOU_PAGE_OPTIONS)) {
      this.slots.set(
        WidgetType.THANK_YOU_PAGE_OPTIONS,
        new ComponentProvider(
          true,
          import('@app/widgets/thank-you-page-options/thank-you-page-options.component').then(
            (c) => c.ThankYouPageOptionsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.EMI_OPTIONS)) {
      this.slots.set(
        WidgetType.EMI_OPTIONS,
        new ComponentProvider(
          true,
          import('@app/widgets/emi-options/emi-options.component').then(
            (c) => c.EmiOptionsComponent,
          ),
        ),
      );
    }
    // TODO No need to map same component with diffrent identifier
    if (shouldLoadWidget(WidgetType.EMPTY_SEARCH)) {
      this.slots.set(
        WidgetType.EMPTY_SEARCH,
        new ComponentProvider(
          true,
          import('@app/widgets/no-products-found/no-products-found.component').then(
            (c) => c.NoProductsFoundComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.NO_PRODUCTS_FOUND)) {
      this.slots.set(
        WidgetType.NO_PRODUCTS_FOUND,
        new ComponentProvider(
          true,
          import('@app/widgets/no-products-found/no-products-found.component').then(
            (c) => c.NoProductsFoundComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.EXPLORE_OTHER_CATEGORIES)) {
      this.slots.set(
        WidgetType.EXPLORE_OTHER_CATEGORIES,
        new ComponentProvider(
          true,
          import('@app/widgets/explore-other-categories/explore-other-categories.component').then(
            (c) => c.ExploreOtherCategoriesComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.FAMILY_ATTRIBUTES)) {
      this.slots.set(
        WidgetType.FAMILY_ATTRIBUTES,
        new ComponentProvider(
          true,
          import('@app/widgets/family-attributes/family-attributes.component').then(
            (c) => c.FamilyAttributesComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.FILTERS_SORT_BY)) {
      this.slots.set(
        WidgetType.FILTERS_SORT_BY,
        new ComponentProvider(
          true,
          import('@app/widgets/filters-sort-by/filters-sort-by.component').then(
            (c) => c.FiltersSortByComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.GSTIN_VERIFICATION)) {
      this.slots.set(
        WidgetType.GSTIN_VERIFICATION,
        new ComponentProvider(
          true,
          import('@app/widgets/gstin-verification/gstin-verification.component').then(
            (c) => c.GstinVerificationComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.GST_WIDGET)) {
      this.slots.set(
        WidgetType.GST_WIDGET,
        new ComponentProvider(
          true,
          import('@app/widgets/gst-registration/gst-registration.component').then(
            (c) => c.GstRegistrationComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.HEADER_CONTENT)) {
      this.slots.set(
        WidgetType.HEADER_CONTENT,
        new ComponentProvider(
          true,
          import('@app/widgets/header-content/header-content.component').then(
            (c) => c.HeaderContentComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.IB_COIN_INFO_AND_REVIEW_AND_RATINGS)) {
      this.slots.set(
        WidgetType.IB_COIN_INFO_AND_REVIEW_AND_RATINGS,
        new ComponentProvider(
          true,
          import('@app/widgets/ib-coin-info-and-review-ratings-count/ib-coin-info-and-review-ratings-count.component').then(
            (c) => c.IbCoinInfoAndReviewRatingsCountComponent,
          ),
        ),
      );
    }
    if (shouldLoadWidget(WidgetType.LIST_GRID)) {
      this.slots.set(
        WidgetType.LIST_GRID,
        new ComponentProvider(
          true,
          import('@app/widgets/list-grid-view/list-grid-view.component').then(
            (c) => c.ListGridViewComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.MULTIMEDIA)) {
      this.slots.set(
        WidgetType.MULTIMEDIA,
        new ComponentProvider(
          true,
          import('@app/widgets/multimedia/multimedia.component').then(
            (i) => i.MultimediaComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.OFFERS_AND_COUPONS)) {
      this.slots.set(
        WidgetType.OFFERS_AND_COUPONS,
        new ComponentProvider(
          true,
          import('@app/widgets/offers-coupons/offers-coupons.component').then(
            (c) => c.OffersCouponsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.OMU)) {
      this.slots.set(
        WidgetType.OMU,
        new ComponentProvider(
          true,
          import('@app/widgets/banners-widget/banners-widget.component').then(
            (i) => i.BannersWidgetComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.OUT_OF_STOCK_FORM)) {
      this.slots.set(
        WidgetType.OUT_OF_STOCK_FORM,
        new ComponentProvider(
          true,
          import('@app/widgets/out-of-stock/out-of-stock.component').then(
            (c) => c.OutOfStockComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PLP_FILTERS)) {
      this.slots.set(
        WidgetType.PLP_FILTERS,
        new ComponentProvider(
          true,
          import('@app/widgets/filters/filters.component').then(
            (c) => c.FiltersComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PMU_V2)) {
      this.slots.set(
        WidgetType.PMU_V2,
        new ComponentProvider(
          true,
          import('@app/widgets/product-carousel/product-carousel.component').then(
            (i) => i.ProductCarouselComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PRODUCT_FEATURES)) {
      this.slots.set(
        WidgetType.PRODUCT_FEATURES,
        new ComponentProvider(
          true,
          import('@app/widgets/product-features/product-features.component').then(
            (c) => c.ProductFeaturesComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PRODUCT_PAGE_SUMMARY)) {
      this.slots.set(
        WidgetType.PRODUCT_PAGE_SUMMARY,
        new ComponentProvider(
          true,
          import('@app/widgets/product-page-summary/product-page-summary.component').then(
            (c) => c.ProductPageSummaryComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PRODUCT_PRICE_SUMMARY)) {
      this.slots.set(
        WidgetType.PRODUCT_PRICE_SUMMARY,
        new ComponentProvider(
          true,
          import('@app/widgets/product-price-summary/product-price-summary.component').then(
            (c) => c.ProductPriceSummaryComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.CUSTOM_PRICING)) {
      this.slots.set(
        WidgetType.CUSTOM_PRICING,
        new ComponentProvider(
          true,
          import('@app/widgets/quotation-card/quotation-card.component').then(
            (c) => c.QuotationCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PRODUCT_SUMMARY_GRID)) {
      this.slots.set(
        WidgetType.PRODUCT_SUMMARY_GRID,
        new ComponentProvider(
          true,
          import('@app/widgets/product-summary/product-summary.component').then(
            (c) => c.ProductSummaryComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PRODUCT_SUMMARY_LIST)) {
      this.slots.set(
        WidgetType.PRODUCT_SUMMARY_LIST,
        new ComponentProvider(
          true,
          import('@app/widgets/product-summary-list/product-summary-list.component').then(
            (c) => c.ProductSummaryListComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.QUANTITY_CHANGE)) {
      this.slots.set(
        WidgetType.QUANTITY_CHANGE,
        new ComponentProvider(
          true,
          import('@app/widgets/quantity-change/quantity-change.component').then(
            (c) => c.QuantityChangeComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.REQUEST_CALLBACK)) {
      this.slots.set(
        WidgetType.REQUEST_CALLBACK,
        new ComponentProvider(
          true,
          import('@app/widgets/request-callback/request-callback.component').then(
            (c) => c.RequestCallbackComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.REVIEW_AND_RATINGS)) {
      this.slots.set(
        WidgetType.REVIEW_AND_RATINGS,
        new ComponentProvider(
          true,
          import('@app/widgets/review-and-ratings/review-and-ratings.component').then(
            (c) => c.ReviewAndRatingsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.SEARCH_PRODUCTS_COUNT)) {
      this.slots.set(
        WidgetType.SEARCH_PRODUCTS_COUNT,
        new ComponentProvider(
          true,
          import('@app/widgets/search-products-count/search-products-count.component').then(
            (c) => c.SearchProductsCountComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.SEO)) {
      this.slots.set(
        WidgetType.SEO,
        new ComponentProvider(
          true,
          import('@app/widgets/seo/seo.component').then((i) => i.SeoComponent),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.SORT_BY)) {
      this.slots.set(
        WidgetType.SORT_BY,
        new ComponentProvider(
          true,
          import('@app/widgets/sort-by/sort-by.component').then(
            (c) => c.SortByComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.TEXT_CARD)) {
      this.slots.set(
        WidgetType.TEXT_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/text-card/text-card.component').then(
            (i) => i.TextCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.TEXT_HEADING)) {
      this.slots.set(
        WidgetType.TEXT_HEADING,
        new ComponentProvider(
          true,
          import('@app/widgets/text-heading/text-heading.component').then(
            (c) => c.TextHeadingComponent,
          ),
        ),
      );
      if (shouldLoadWidget(WidgetType.BANK_ACCOUNT_VIEWER)) {
        this.slots.set(
          WidgetType.BANK_ACCOUNT_VIEWER,
          new ComponentProvider(
            true,
            import('@app/widgets/bank-account-viewer/bank-account-viewer.component').then(
              (c) => c.BankAccountViewerComponent,
            ),
          ),
        );
      }
      if (shouldLoadWidget(WidgetType.BANK_ACCOUNT_FORM)) {
        this.slots.set(
          WidgetType.BANK_ACCOUNT_FORM,
          new ComponentProvider(
            true,
            import('@app/widgets/bank-account-form/bank-account-form.component').then(
              (c) => c.BankAccountFormComponent,
            ),
          ),
        );
      }
      if (shouldLoadWidget(WidgetType.REVIEW_PROGRESS_BAR)) {
        this.slots.set(
          WidgetType.REVIEW_PROGRESS_BAR,
          new ComponentProvider(
            true,
            import('@app/widgets/review-progress-monitor/review-progress-monitor.component').then(
              (c) => c.ReviewProgressMonitorComponent,
            ),
          ),
        );
      }
    }
    if (shouldLoadWidget(WidgetType.VIEW_ALL)) {
      this.slots.set(
        WidgetType.VIEW_ALL,
        new ComponentProvider(
          true,
          import('@app/widgets/view-all/view-all.component').then(
            (c) => c.ViewAllComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ICON_WITH_TEXT_LIST)) {
      this.slots.set(
        WidgetType.ICON_WITH_TEXT_LIST,
        new ComponentProvider(
          true,
          import('@app/widgets/icon-with-text-list/icon-with-text-list.component').then(
            (c) => c.IconWithTextListComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PROFILE_CARD)) {
      this.slots.set(
        WidgetType.PROFILE_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/profile-card/profile-card.component').then(
            (c) => c.ProfileCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ORDER_VIEWER)) {
      this.slots.set(
        WidgetType.ORDER_VIEWER,
        new ComponentProvider(
          true,
          import('@app/widgets/order-viewer/order-viewer.component').then(
            (c) => c.OrderViewerComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ADDRESS)) {
      this.slots.set(
        WidgetType.ADDRESS,
        new ComponentProvider(
          true,
          import('@app/widgets/address/address.component').then(
            (c) => c.AddressComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ADDRESS_FORM)) {
      this.slots.set(
        WidgetType.ADDRESS_FORM,
        new ComponentProvider(
          true,
          import('@app/widgets/address-form/address-form.component').then(
            (i) => i.AddressFormComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PASSWORD_CHANGER)) {
      this.slots.set(
        WidgetType.PASSWORD_CHANGER,
        new ComponentProvider(
          true,
          import('@app/widgets/password-changer/password-changer.component').then(
            (c) => c.PasswordChangerComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ATLAS_WIDGET)) {
      this.slots.set(
        WidgetType.ATLAS_WIDGET,
        new ComponentProvider(
          true,
          import('@app/widgets/all-brands/all-brands.component').then(
            (c) => c.AllBrandsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.SEARCH_BAR)) {
      this.slots.set(
        WidgetType.SEARCH_BAR,
        new ComponentProvider(
          true,
          import('@app/widgets/search-bar/search-bar.component').then(
            (c) => c.SearchBarComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.DROPDOWN)) {
      this.slots.set(
        WidgetType.DROPDOWN,
        new ComponentProvider(
          true,
          import('@app/widgets/dropdown/dropdown.component').then(
            (c) => c.DropDownComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.REUSABLE_PAGINATION_BAR)) {
      this.slots.set(
        WidgetType.REUSABLE_PAGINATION_BAR,
        new ComponentProvider(
          true,
          import('@app/widgets/reusable-pagination-bar/reusable-pagination-bar.component').then(
            (c) => c.ReusablePaginationBarComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.PDP_MEDIA)) {
      this.slots.set(
        WidgetType.PDP_MEDIA,
        new ComponentProvider(
          true,
          import('@app/widgets/pdp-review-media/pdp-review-media.component').then(
            (c) => c.PDPReviewMediaComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.GST_INFO_CARD)) {
      this.slots.set(
        WidgetType.GST_INFO_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/gst-info-card/gst-info-card.component').then(
            (c) => c.GstInfoCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.TESTIMONIAL)) {
      this.slots.set(
        WidgetType.TESTIMONIAL,
        new ComponentProvider(
          true,
          import('@app/widgets/client-testimonials/client-testimonials.component').then(
            (i) => i.ClientTestimonialsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.TEXT)) {
      this.slots.set(
        WidgetType.TEXT,
        new ComponentProvider(
          true,
          import('@app/widgets/text/text.component').then(
            (c) => c.TextComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.TABLE_CONTENT)) {
      this.slots.set(
        WidgetType.TABLE_CONTENT,
        new ComponentProvider(
          true,
          import('@app/widgets/table-content/table-content.component').then(
            (c) => c.TableContentComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.BANK_ACCOUNT_VIEWER)) {
      this.slots.set(
        WidgetType.BANK_ACCOUNT_VIEWER,
        new ComponentProvider(
          true,
          import('@app/widgets/bank-account-viewer/bank-account-viewer.component').then(
            (c) => c.BankAccountViewerComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.BANK_ACCOUNT_FORM)) {
      this.slots.set(
        WidgetType.BANK_ACCOUNT_FORM,
        new ComponentProvider(
          true,
          import('@app/widgets/bank-account-form/bank-account-form.component').then(
            (c) => c.BankAccountFormComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.REVIEW_PROGRESS_BAR)) {
      this.slots.set(
        WidgetType.REVIEW_PROGRESS_BAR,
        new ComponentProvider(
          true,
          import('@app/widgets/review-progress-monitor/review-progress-monitor.component').then(
            (c) => c.ReviewProgressMonitorComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.REVIEW_PAGE)) {
      this.slots.set(
        WidgetType.REVIEW_PAGE,
        new ComponentProvider(
          true,
          import('@app/widgets/reviewer/reviewer.component').then(
            (c) => c.ReviewerComponent,
          ),
        ),
      );
    }
    if (shouldLoadWidget(WidgetType.REVIEW_CARD)) {
      this.slots.set(
        WidgetType.REVIEW_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/review-viewer/review-viewer.component').then(
            (c) => c.ReviewViewerComponent,
          ),
        ),
      );
    }

    // this.slots.set(WidgetType.FAMILY_ITEMS, FamilyItemsComponent);

    if (shouldLoadWidget(WidgetType.RETURNS_TABLE)) {
      this.slots.set(
        WidgetType.RETURNS_TABLE,
        new ComponentProvider(
          true,
          import('@app/widgets/return-viewer/return-viewer.component').then(
            (c) => c.ReturnViewerComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.MEDIA_UPLOAD)) {
      this.slots.set(
        WidgetType.MEDIA_UPLOAD,
        new ComponentProvider(
          true,
          import('@app/widgets/media-uploader/media-uploader.component').then(
            (c) => c.MediaUploaderComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ORDER_STATE_PRODUCT_CARD)) {
      this.slots.set(
        WidgetType.ORDER_STATE_PRODUCT_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/order-state-item-card/order-state-item-card.component').then(
            (c) => c.OrderStateItemCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.FORM)) {
      this.slots.set(
        WidgetType.FORM,
        new ComponentProvider(
          true,
          import('@app/widgets/form/form.component').then(
            (c) => c.FormComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.FIXED_FEATURES_SPECIFICATIONS)) {
      this.slots.set(
        WidgetType.FIXED_FEATURES_SPECIFICATIONS,
        new ComponentProvider(
          true,
          import('@app/widgets/popups/product-detail-specification/product-detail-specification.component').then(
            (c) => c.ProductDetailSpecificationComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.FAMILY_PRODUCT_LISTING)) {
      this.slots.set(
        WidgetType.FAMILY_PRODUCT_LISTING,
        new ComponentProvider(
          true,
          import('@app/widgets/family-products-viewer/family-products-viewer.component').then(
            (c) => c.FamilyProductsViewerComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ACCORDION)) {
      this.slots.set(
        WidgetType.ACCORDION,
        new ComponentProvider(
          true,
          import('@app/widgets/accordion/accordion.component').then(
            (c) => c.AccordionComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.SIDE_BAR)) {
      this.slots.set(
        WidgetType.SIDE_BAR,
        new ComponentProvider(
          true,
          import('@app/widgets/sidebar/sidebar.component').then(
            (c) => c.SidebarComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.WHATSAPP_CHAT)) {
      this.slots.set(
        WidgetType.WHATSAPP_CHAT,
        new ComponentProvider(
          true,
          import('@app/widgets/whatsapp-chat/whatsapp-chat.component').then(
            (c) => c.WhatsappChatComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.HIGH_VALUE_PDP)) {
      this.slots.set(
        WidgetType.HIGH_VALUE_PDP,
        new ComponentProvider(
          true,
          import('@app/widgets/high-value-pdp/high-value-pdp.component').then(
            (c) => c.HighValuePdpComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.DIVIDER)) {
      this.slots.set(
        WidgetType.DIVIDER,
        new ComponentProvider(
          true,
          import('@app/widgets/divider/divider.component').then(
            (c) => c.Divider,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.CUSTOMER_HELPLINE_OPTIONS)) {
      this.slots.set(
        WidgetType.CUSTOMER_HELPLINE_OPTIONS,
        new ComponentProvider(
          true,
          import('@app/widgets/helpline-options-pdp/helpline-options-pdp.component').then(
            (c) => c.HelplineOptionsPdpComponent,
          ),
        ),
      );
    }
    if (shouldLoadWidget(WidgetType.USER_QUOTE)) {
      this.slots.set(
        WidgetType.USER_QUOTE,
        new ComponentProvider(
          true,
          import('@app/widgets/user-quote/user-quote.component').then(
            (c) => c.UserQuoteComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.IB_CREDIT_ORDER_CARD)) {
      this.slots.set(
        WidgetType.IB_CREDIT_ORDER_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/ib-credit-order-card/ib-credit-order-card.component').then(
            (c) => c.IbCreditOrderCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.IB_CREDIT_PAYMENT_DETAIL_CARD)) {
      this.slots.set(
        WidgetType.IB_CREDIT_PAYMENT_DETAIL_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/credit-payment-detail-card/credit-payment-detail-card.component').then(
            (c) => c.CreditPaymentDetailCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.IB_CREDIT_HOW_IT_WORK)) {
      this.slots.set(
        WidgetType.IB_CREDIT_HOW_IT_WORK,
        new ComponentProvider(
          true,
          import('@app/widgets/ib-credit/how-it-works/how-it-works.component').then(
            (c) => c.IbCreditHowItWorksComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.NPS_THANK_YOU_SUBMISSION)) {
      this.slots.set(
        WidgetType.NPS_THANK_YOU_SUBMISSION,
        new ComponentProvider(
          true,
          import('@app/widgets/nps-thankyou-widget/nps-thankyou-widget.component').then(
            (c) => c.NpsThankyouWidgetComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.IB_CREDIT_PAYMENT)) {
      this.slots.set(
        WidgetType.IB_CREDIT_PAYMENT,
        new ComponentProvider(
          true,
          import('@app/widgets/popups/ib-credit-payments-dialog/ib-credit-payments-dialog.component').then(
            (c) => c.IbCreditPaymentsDialogComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ARTICLES_CARD)) {
      this.slots.set(
        WidgetType.ARTICLES_CARD,
        new ComponentProvider(
          true,
          import('@app/widgets/articles-card/articles-card.component').then(
            (c) => c.ArticlesCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.ARTICLES_DETAIL_COMPONENT)) {
      this.slots.set(
        WidgetType.ARTICLES_DETAIL_COMPONENT,
        new ComponentProvider(
          true,
          import('@app/widgets/articles-detail-component/articles-detail.component').then(
            (c) => c.ArticlesDetailComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.REVIEW_CARD_REDIRECT)) {
      this.slots.set(
        WidgetType.REVIEW_CARD_REDIRECT,
        new ComponentProvider(
          true,
          import('@app/widgets/review-card.component/review-card.component').then(
            (c) => c.ReviewCardComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.GRIEVANCE_REDRESSAL)) {
      this.slots.set(
        WidgetType.GRIEVANCE_REDRESSAL,
        new ComponentProvider(
          true,
          import('@app/widgets/grievance-redressal/grievance-redressal.component').then(
            (c) => c.GrievanceRedressalComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.FAQS)) {
      this.slots.set(
        WidgetType.FAQS,
        new ComponentProvider(
          true,
          import('@app/widgets/faqs/faqs.component').then(
            (c) => c.FaqsComponent,
          ),
        ),
      );
    }

    if (shouldLoadWidget(WidgetType.IB_CREDIT_ELIGIBILITY)) {
      this.slots.set(
        WidgetType.IB_CREDIT_ELIGIBILITY,
        new ComponentProvider(
          true,
          import('@app/widgets/ib-credit-eligibility/ib-credit-eligibility.component').then(
            (c) => c.IbCreditEligibilityComponent,
          ),
        ),
      );
    }
  }

  getSlots() {
    return this.slots;
  }

  private importPopupsDynamically() {
    if (this.dynamicModals.size > 0) {
      return;
    }
    this.dynamicModals.set(
      ModalType.EMI_OPTIONS,
      import('@app/widgets/popups/emi-options-popup/emi-options-popup.component').then(
        (i) => i.EmiOptionsPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.PROMOS_AND_COUPONS,
      import('@app/widgets/popups/view-all-coupons/view-all-coupons.component').then(
        (i) => i.ViewAllCouponsComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.EXPLORE_FAMILIES,
      import('@app/widgets/popups/explore-families/explore-families.component').then(
        (i) => i.ExplorefamiliesComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.MORE_FILTER_OPTIONS,
      import('@app/widgets/popups/more-filter-options/more-filter-options.component').then(
        (i) => i.MoreFilterOptionsComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.PAYMENT_DIALOG,
      import('@app/widgets/popups/payment-dialog/payment-dialog.component').then(
        (i) => i.PaymentDialogComponent,
      ),
    );
    this.dynamicModals.set(
      ModalType.DESCRIPTION_AND_SPECIFICATIONS,
      import('@app/widgets/popups/product-detail-specification/product-detail-specification.component').then(
        (i) => i.ProductDetailSpecificationComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.MULTIMEDIA,
      import('@app/widgets/multimedia/multimedia.component').then(
        (i) => i.MultimediaComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.ALL_CATEGORIES_DIALOG,
      import('@app/widgets/popups/all-categories-popup/all-categories-popup.component').then(
        (i) => i.AllCategoriesPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.PDP_REQUESTS,
      import('@app/widgets/popups/pdp-requests-popup/pdp-requests-popup.component').then(
        (i) => i.PdpRequestsPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.POLICY_POPUP,
      import('@app/widgets/popups/policy-popup/policy-popup.component').then(
        (i) => i.PolicyPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.WRITE_A_REVIEW_POPUP,
      import('@app/widgets/popups/write-a-review-popup/write-a-review-popup.component').then(
        (i) => i.WriteAReviewPopup,
      ),
    );

    this.dynamicModals.set(
      ModalType.BRAND_CATEGORY_LISTING,
      import('@app/widgets/popups/brand-category-listing/brand-category-listing.component').then(
        (i) => i.BrandCategoryListingComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.COMMON_CONFIRMATION_POPUP,
      import('@app/widgets/popups/common-confirmation-popup/common-confirmation-popup.component').then(
        (i) => i.CommonConfirmationPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.ERROR_POPUP,
      import('@app/widgets/popups/error-popup/error-popup.component').then(
        (i) => i.ErrorPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.HIGH_VALUE,
      import('@app/widgets/high-value-pdp/high-value-pdp.component').then(
        (i) => i.HighValuePdpComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.QUOTATION_POPUP,
      import('@app/widgets/popups/quotation-popup/quotation-popup.component').then(
        (i) => i.QuotationPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.IB_CREDIT_PAYMENT_DIALOG,
      import('@app/widgets/popups/ib-credit-payments-dialog/ib-credit-payments-dialog.component').then(
        (i) => i.IbCreditPaymentsDialogComponent,
      ),
    );
    this.dynamicModals.set(
      ModalType.REVIEW_POPUP,
      import('@app/widgets/popups/review-popup/review-popup.component').then(
        (i) => i.ReviewPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.MULTISELECT_POPUP,
      import('@app/widgets/popups/MultiSelectComponent/multi-select.component').then(
        (i) => i.MultiSelectComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.IB_CREDIT_CONFIRMATION_POPUP,
      import('@app/widgets/ib-credit-eligibility/registration-page/registration-page.component').then(
        (i) => i.RegistrationPageComponent,
      ),
    );
  }

  async getModalComponent(type: string): Promise<any> {
    if (this.loadedModals.has(type)) {
      return this.loadedModals.get(type);
    }
    this.importPopupsDynamically();
    const promise = this.dynamicModals.get(type);
    if (!promise) return undefined;
    const component = await promise;
    this.loadedModals.set(type, component);
    return component;
  }

  private saveComponent(name: string, component: any) {
    if (!this.loadedComponents.has(name)) {
      this.loadedComponents.set(name, component);
    }
  }

  async getSavedComponent(name: string): Promise<any> {
    if (this.loadedComponents.has(name)) {
      return this.loadedComponents.get(name);
    }
    this.setSlots([name as WidgetType]);
    const provider = this.slots.get(name);
    if (!provider) return undefined;
    const component = provider.lazy
      ? await provider.component
      : provider.component;
    this.saveComponent(name, component);
    return component;
  }
}

export class ComponentProvider {
  lazy = false;
  component: any;

  constructor(lazy: boolean, component: any) {
    this.lazy = lazy;
    this.component = component;
  }
}
